// removed by extract-text-webpack-plugin
module.exports = {"forms":"c-LoginWrapper__forms","info":"c-LoginWrapper__info","text":"c-LoginWrapper__text"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/LoginWrapper/LoginWrapper.scss
// module id = 1112
// module chunks = 0